const ArrowMenu = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`arrow ${className}`}
    >
      <path
        d="M9 7.75603L9 16.244C9.00066 16.3941 9.04768 16.5407 9.13513 16.6652C9.22258 16.7897 9.34653 16.8865 9.4913 16.9434C9.63607 17.0003 9.79516 17.0147 9.94846 16.9848C10.1018 16.9549 10.2424 16.882 10.3525 16.7754L14.766 12.539C14.8402 12.4685 14.899 12.3845 14.9392 12.292C14.9793 12.1995 15 12.1002 15 12C15 11.8998 14.9793 11.8005 14.9392 11.708C14.899 11.6155 14.8402 11.5315 14.766 11.461L10.3525 7.22458C10.2424 7.11797 10.1018 7.04511 9.94846 7.01521C9.79516 6.98531 9.63607 6.99971 9.4913 7.05659C9.34653 7.11348 9.22258 7.21029 9.13513 7.33478C9.04768 7.45928 9.00066 7.60587 9 7.75603V7.75603Z"
        fill="black"
      />
    </svg>
  );
};

export default ArrowMenu;
